import { FaArrowRight } from "react-icons/fa";

const ConcreteExample = () => {
    return (
        <section className="rounded-3xl bg-secondaryDark px-6 py-16 md:px-12 md:py-20">
            <div className="max-w-2xl">
                <h2 className="text-2xl font-bold text-white md:text-3xl">Un exemple concret</h2>
                <p className="mt-4 leading-relaxed text-secondaryExtraLight">
                    Pour comprendre simplement comment un prêt génère un revenu, à titre indicatif.
                </p>
            </div>

            <div className="mt-10 grid grid-cols-1 items-center gap-7 md:grid-cols-[1fr_auto_1fr]">
                <div className="rounded-2xl border border-white/10 bg-secondary/40 p-8">
                    <p className="mb-3 text-xs font-semibold text-accent">Aujourd'hui</p>
                    <p className="text-xl leading-snug text-white">
                        Camille investit <b className="font-semibold text-accent">5 000 €</b> sur un prêt d'une
                        durée de <b className="font-semibold text-accent">24 mois</b>, au taux moyen brut de{" "}
                        <b className="font-semibold text-accent">9,95 %</b>.
                    </p>
                    <p className="mt-4 text-sm leading-relaxed text-secondaryExtraLight">
                        Les fonds sont alloués à une entreprise sélectionnée par PretUp, avec une sûreté adossée au
                        prêt.
                    </p>
                </div>

                <div className="flex flex-col items-center gap-2 text-xs text-gray-400">
                    <FaArrowRight className="rotate-90 text-accent md:rotate-0" size={30} />
                    24 mois plus tard
                </div>

                <div className="rounded-2xl border border-white/10 bg-secondary/40 p-8">
                    <p className="mb-3 text-xs font-semibold text-accent">À l'échéance</p>
                    <p className="text-xl leading-snug text-white">
                        Camille a perçu <b className="font-semibold text-accent">5 995 €</b> au total : ses{" "}
                        <b className="font-semibold text-accent">5 000 €</b> de capital et environ{" "}
                        <b className="font-semibold text-accent">995 €</b> de revenus bruts.
                    </p>
                    <p className="mt-4 text-sm leading-relaxed text-secondaryExtraLight">
                        Calcul indicatif : (9,95 % × 5 000 €) / 12 × 24 mois — avant coût du risque et fiscalité,
                        hors frais (0 € chez PretUp).
                    </p>
                </div>
            </div>

            <p className="mt-8 max-w-4xl text-xs leading-relaxed text-gray-400">
                * Simulation à titre pédagogique et indicatif, sur la base du taux moyen brut constaté en 2026.
                Elle ne tient pas compte du profil de risque du prêt ni du coût du risque moyen historique (1,84 %
                sur 10 ans). Les performances passées ne préjugent pas des performances futures ; investir comporte
                un risque de perte en capital.
            </p>
        </section>
    );
};

export default ConcreteExample;
